module.exports = __webpack_public_path__ + "static/media/rank3.faa5f453.png";